import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import { getRiskLevelsAsOption } from '../../../utils/data';
import { getFileUploadTypes } from '../../../utils/utilities';

class VTPipingAnomalyItem extends Form {
	state = {
		data: {
			lineNumber: '',
			pIDNumber: '',
			description: '',
			recommendation: '',
			level: '',
			images: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		lineNumber: Joi.string().min(3).required().label('Line Number'),
		pIDNumber: Joi.string().min(3).required().label('P&ID Number'),
		description: Joi.string().min(10).required().label('Anomaly Description'),
		recommendation: Joi.string().required().label('recommendation'),
		level: Joi.string().required().label('Criticality'),
		images: Joi.array().min(1).required().label('Anomaly Image'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				lineNumber: '',
				pIDNumber: '',
				description: '',
				recommendation: '',
				level: '',
				images: [],
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'lineNumber',
							placeholder: 'Enter Line Number',
							label: 'Line Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'pIDNumber',
							placeholder: 'Enter P & ID Number',
							label: 'P & ID Number',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'level',
							placeholder: 'Select Criticality',
							label: 'Criticality',
							options: getRiskLevelsAsOption(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'description',
							placeholder: 'Enter Anomaly Description',
							label: 'Anomaly Description',
							rows: '6',
						})}
					</div>

					<div className="col">
						{this.renderTextArea({
							name: 'recommendation',
							placeholder: 'Enter Recommendation',
							label: 'Recommendation',
							rows: '6',
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 2,
							multiple: true,
							name: 'images',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image',
							sublabel: 'Upload photos showing anomaly',
							types: getFileUploadTypes(),
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default VTPipingAnomalyItem;
